const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'https://api-plaid.demotrt.com';

export const plaidApi = {
  // Create Link Token
  createLinkToken: async () => {
    const response = await fetch(`${API_BASE_URL}/api/create_link_token`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      throw new Error("Failed to create link token");
    }

    return response.json();
  },

  // Exchange Public Token for Access Token
  setAccessToken: async (publicToken: string) => {
    const response = await fetch(`${API_BASE_URL}/api/set_access_token`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ public_token: publicToken }),
    });

    if (!response.ok) {
      throw new Error("Failed to exchange public token");
    }

    return response.json();
  },

  // Get Transactions
  getTransactions: async (accessToken: string) => {
    const response = await fetch(`${API_BASE_URL}/api/transactions`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
    });

    if (!response.ok) {
      throw new Error("Failed to fetch transactions");
    }

    return response.json();
  },

  // Get Balance
  getBalance: async (accessToken: string) => {
    const response = await fetch(`${API_BASE_URL}/api/balance`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
    });

    if (!response.ok) {
      throw new Error("Failed to fetch balance");
    }

    return response.json();
  },

  // Get Auth
  getAuth: async (accessToken: string) => {
    const response = await fetch(`${API_BASE_URL}/api/auth`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
    });

    if (!response.ok) {
      throw new Error("Failed to fetch auth data");
    }

    return response.json();
  },
};
